
export class empDeptRequest {
    employeeId?:number;
    department?: number;
}